module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Notification.f869c3ca.svg";